import { render } from "./PlatformList.vue?vue&type=template&id=2570ec22&scoped=true"
import script from "./PlatformList.vue?vue&type=script&lang=js"
export * from "./PlatformList.vue?vue&type=script&lang=js"

import "./PlatformList.vue?vue&type=style&index=0&id=2570ec22&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2570ec22"]])

export default __exports__